import { isAfter, startOfDay } from 'date-fns';
import { Assignment } from '../providers/api/dtos';

export const isAssignmentExpired = (assignment: Assignment): boolean => {
  if (!assignment.endDate) return false;

  return isAfter(startOfDay(new Date()), new Date(assignment.endDate));
};
